
var cartData = null;
var twoClickBuy = false;

const wrappingVariantIds = {
  // ラッピング
  '巾着': 44211484295384,
  'ギフトBOX': 44211491340504,
  '巾着＆ギフトBOX': 44211492782296,

  // メッセージタグ
  'THANK YOU': 44337379082456,
  'FOR YOU': 44337389633752,
  'CONGRATULATIONS': 45237980791000,
  'GET WELL SOON': 44337392943320,

  // サンプルプレゼント
  'クイックオールインワンジェル': 45042922422488,
  'ミルクフェイスウォッシュ': 45042953781464,
};

const wrappingVariantIdToNames = {
  // ラッピング
  44211484295384: '巾着',
  44211491340504: 'ギフトBOX',
  44211492782296: '巾着＆ギフトBOX',

  // メッセージタグ
  44337379082456: 'THANK YOU',
  44337389633752: 'FOR YOU',
  45237980791000: 'CONGRATULATIONS',
  44337392943320: 'GET WELL SOON',

  // サンプルプレゼント
  45042922422488: 'クイックオールインワンジェル',
  45042953781464: 'ミルクフェイスウォッシュ',
};

document.addEventListener('DOMContentLoaded', async () => {

  if(document.location.pathname.match(/cart/)) {

    $(function(){
      $("input"). keydown(function(e) {
        if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
          return false;
        } else {
          return true;
        }
      });
    });

    await reloadCartData();
    setCartBadge();
    cartDisplayEdit();

  }else{
    await reloadCartData();
    setCartBadge();
    changeAddCartBtn();
  }

  // SP メニューの商品一覧カテゴリ開閉
  $('.nav-items_item--productList').on('click', () => {
    if(window.innerWidth <= 1050){
      $('.nav-items_item--productList').toggleClass('nav-items_item--productList--active');
      $('.nav-cats').slideToggle();
    }
  });

});


function reloadCartData() {

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "GET",
      url: "/cart.json",
      dataType: 'json',
      contentType: 'json',
    }).done(function( data ) {
      console.log(data);

      cartData = data.items;

      resolve();

    }).fail(function(XMLHttpRequest, textStatus, errorThrown){
      console.log(errorThrown);
      reject();
    });
  });

}

function setCartBadge() {

  if(cartData === null || cartData === undefined || cartData.length == 0){
    $('#js-cartBadge').hide();
    $('#js-cartBadge').html('');
    return;
  }

  var count = 0;
  for(var i=0; i<cartData.length; i++){
    const title = cartData[i].product_title;
    if(title.indexOf('ラッピング') == -1 && title.indexOf('メッセージタグ') == -1 && title.indexOf('サンプルパウチ') == -1){
      count++;
    }
  }

  if(count > 0){
    $('#js-cartBadge').html(''+count);
    $('#js-cartBadge').fadeIn(200);
  }else{
    $('#js-cartBadge').hide();
    $('#js-cartBadge').html('');
  }

}


var requiredDispCautionForPreorder = false;
var cartContainType = '通常商品';
var selectedBuyAction = 'addCart';

function onClickAddCartBtn(type, e) {
  if(type == 'addCart'){
    selectedBuyAction = 'addCart';
  }else if(type == 'twoClickBuy'){
    selectedBuyAction = 'twoClickBuy';
  }

  if(!requiredDispCautionForPreorder){
    // 通常商品の挙動
    agreeCautionForPreorder(e);
  }else{
    // 予約商品＋通常商品の挙動
    $('#js-modalCaution-type').html(cartContainType);
    openCautionForPreorder();
  }
}
function agreeCautionForPreorder(e) {

  $('.buyBtns').addClass('disabled');
  $(e).addClass('pushed');

  if(selectedBuyAction == 'addCart'){
    $('#ProductSubmitButton').click();
  }else if(selectedBuyAction == 'twoClickBuy'){
    twoClickBuy = true;
    $('#ProductSubmitButton').click();
  }
}

function openCautionForPreorder() {
  $('#js-modalCautionBg').fadeIn(250);
  $('#js-modalCaution').fadeIn(250);
}
function closeCautionForPreorder() {
  $('#js-modalCautionBg').fadeOut(250);
  $('#js-modalCaution').fadeOut(250);
}

function cartDisplayEdit() {
  var disableSelectShippingTime = false;
  var miniBottle = 0;
  var otherItem = false;
  for(var i=0; i<cartData.length; i++){
    const giftAttr = cartData[i].properties['ギフト購入'];
    if(giftAttr){
      // eギフトあり
      disableSelectShippingTime = true;
      break;
    }

    const type = cartData[i].properties['_販売種別'];
    if(type && type == 'ミニボトル'){
      // 予約商品あり
      miniBottle += cartData[i].quantity;
    }else{
      otherItem = true;
    }
  }

  if(miniBottle >= 1 && miniBottle <= 2 && !otherItem){
    // ミニボトルのみ
    disableSelectShippingTime = true;
  }

  if(disableSelectShippingTime){
    $('.app_block').hide();
  }else{
    $('.app_block').show();
  
  }
}

function changeAddCartBtn() {

  if(!document.location.pathname.match(/products/)) {
    return;
  }

  const saleType = $('#js-saleType').val();

  var reserved = false;
  var regular = false;
  
  for(var i=0; i<cartData.length; i++){
    const type = cartData[i].properties['_販売種別'];
    if(type){
      if(type == '予約'){
        reserved = true;
      }else if(type == '定期便'){
        regular = true;
      }
      break;
    }
  }

  if(cartData.length > 0){

    // 予約商品＋その他商品
    if(saleType == '予約' && reserved){

      cartContainType = '【予約商品について】';
      requiredDispCautionForPreorder = true;

    }else if(saleType != '予約' && reserved){

      cartContainType = '【カートに予約商品が含まれます】';
      requiredDispCautionForPreorder = true;

    }else if(saleType == '予約' && !reserved){

      cartContainType = '【カートに通常商品が含まれます】';
      requiredDispCautionForPreorder = true;

    }

    // 定期便＋その他商品
    if(saleType != '定期便' && regular){

      $('#js-btnBuyBox').html(`
        <p class="buy_caution_title">
          定期便の商品がカートに入っています
        </p>
        <p class="buy_caution_desc">
          定期便とその他の商品を同時に購入できません。
        </p>
        <a class="btnGoCart" href="/cart">カート画面へ</a>
        <div style="display: none;">
          <div data-anygift="marker"></div>
        </div>
      `);
      
    }else if(saleType == '定期便' && !regular){

      $('#js-btnBuyBox').html(`
        <p class="buy_caution_title">
          定期便以外の商品がカートに入っています
        </p>
        <p class="buy_caution_desc">
          定期便とその他の商品を同時に購入できません。
        </p>
        <a class="btnGoCart" href="/cart">カート画面へ</a>
        <div style="display: none;">
          <div data-anygift="marker"></div>
        </div>
      `);

    }

  }else{
    // カートが空の場合

    if(saleType == '予約'){

      cartContainType = '【予約商品について】';
      requiredDispCautionForPreorder = true;

    }

  }


  $('#js-btnBuyBox').fadeIn(200);

}


function addCartItem(variantId, quantity) {

  var postData = {
    items: [
      {
        id: variantId,
        quantity: quantity
      }
    ]
  };

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: 'json',
      contentType: 'json',
      data: JSON.stringify(postData),
      headers: {
        'Content-Type': 'application/json'
      },
    }).done(function( data ) {
      console.log(data);
      resolve();

    }).fail(function(XMLHttpRequest, textStatus, errorThrown){
      console.log(errorThrown);
      console.log(XMLHttpRequest);
      console.log(textStatus);
      reject();
    });
  });

}


function changeCartItem(line, variantId, quantity) {

  var postData = null;

  if(line === null || line === undefined){
    postData = {id: variantId, quantity: quantity};
  }else{
    postData = {line: line, quantity: quantity};
  }

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: 'json',
      contentType: 'json',
      data: JSON.stringify({line: line, quantity: quantity}),
      headers: {
        'Content-Type': 'application/json'
      },
    }).done(function( data ) {
      console.log(data);
      resolve();

    }).fail(function(XMLHttpRequest, textStatus, errorThrown){
      console.log(errorThrown);
      reject();
    });
  });

}


function deleteCartItem(variantId) {

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: 'json',
      contentType: 'json',
      data: JSON.stringify({id: variantId, quantity: 0}),
      headers: {
        'Content-Type': 'application/json'
      },
    }).done(function( data ) {
      console.log(data);
      resolve();

    }).fail(function(XMLHttpRequest, textStatus, errorThrown){
      console.log(errorThrown);
      reject();
    });
  });

}


function updateCustomerData(id) {

  var postData = {
    type: 1,
    id: id,
    lastName: $('#editFormLastName').val() ?? '',
    firstName: $('#editFormFirstName').val() ?? '',
    phone: $('#editFormPhone').val() ?? '',
    email: $('#editFormEmail').val() ?? '',
    birthDate: $('#editFormBirthDate').val() ?? '',
  }

  console.log(postData);

  const apiURL = 'https://busy-official-app.fly.dev/endpoint';

  $.ajax({
    type: "POST",
    url: apiURL,
    dataType: 'json',
    contentType: 'json',
    data: JSON.stringify(postData),
  }).done(function( data ) {
    console.log(data);

    if(data.result == 1){
      location.href = '/account';
    }else{
      alert('登録に失敗しました。再度お試しください。');
    }
  
  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
    alert('登録に失敗しました。再度お試しください。');
  });

}

function getOptStatus(id) {

  var postData = {
    type: 2,
    id: id,
  }

  console.log(postData);

  const apiURL = 'https://busy-official-app.fly.dev/endpoint';

  $.ajax({
    type: "POST",
    url: apiURL,
    dataType: 'json',
    contentType: 'json',
    data: JSON.stringify(postData),
  }).done(function( data ) {
    console.log(data);

    if(data.result == 1){

      if(data.opt.marketingState == 'SUBSCRIBED'){
        $('.mail_optin').fadeIn(200);
        $('.mail_optout').fadeOut(200);
      }

    }

  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
  });

}


function changeOptStatus(id) {

  var postData = {
    type: 3,
    id: id,
  }

  console.log(postData);

  const apiURL = 'https://busy-official-app.fly.dev/endpoint';

  $.ajax({
    type: "POST",
    url: apiURL,
    dataType: 'json',
    contentType: 'json',
    data: JSON.stringify(postData),
  }).done(function( data ) {
    console.log(data);

    if(data.result == 1){

      window.location.reload();

    }

  }).fail(function(XMLHttpRequest, textStatus, errorThrown){
    console.log(errorThrown);
  });

}


function togglePulldown(e) {

  $(e).parent().find('.pulldown__bg').toggle();
  $(e).parent().find('.pulldown').slideToggle();

}


function selectPulldown(type, e, isToggle) {

  // チェックボックス全解除
  $(e).parent().parent().find('li').removeClass('selected');

  // チェック付ける
  $(e).addClass('selected');

  var name = $(e).find('.pulldown__name').text().trim();

  $(e).parent().parent().find('a').html(name);

  if(isToggle){
    setTimeout(() => {
      togglePulldown($(e).parent());
    }, 150);
  }

  if(type == 'wrapping'){
    if(name == 'なし'){
      if(!$('.message a').hasClass('disabled')){
        $('.message a').addClass('disabled');
      }
      selectPulldown('message', $('.message__pulldown li.pulldown__item--default'), false);
    }else{
      if($('.message a').hasClass('disabled')){
        $('.message a').removeClass('disabled');
      }
      openWrappingModal();
    }
  }

  if(type == 'wrapping'){
    $('#js-wrappingInput').val(name);
  }else if(type == 'message'){
    if(name == 'なし'){
      $('#js-messageInputBox').html('');
    }else{
      $('#js-messageInputBox').html(`
        <input id="js-messageInput" type="hidden" name="properties[メッセージタグ]" value="`+name+`">
      `);
    }
  }else if(type == 'sample'){
    if(name == 'なし'){
      $('#js-sampleInputBox').html('');
    }else{
      $('#js-sampleInputBox').html(`
        <input id="js-sampleInput" type="hidden" name="properties[サンプルプレゼント]" value="`+name+`">
      `);
    }
  }

}

function openWrappingModal() {
  $('#js-modalWrappingBg').fadeIn(250);
  $('#js-modalWrapping').fadeIn(250);
}
function closeWrappingModal() {
  $('#js-modalWrappingBg').fadeOut(250);
  $('#js-modalWrapping').fadeOut(250);
}

// マイページの購入履歴のアコーディオンを開いてスクロール
function openMyOrder() {
  $('.accordion_wide_common_li.myOrder .label').addClass('open');
  $('.accordion_wide_common_li.myOrder .detail').slideDown();

  var offsetY = 50;
  if($(window).width() <= 1050){
    offsetY = -10;
  }

  const targetPos = $('.accordion_wide_common_li.myOrder').offset().top - $(window).scrollTop() - offsetY;
  
  setTimeout(() => {
    window.scroll({
      top: targetPos,
      behavior: 'smooth'
    });
  }, 1000);
  
}

// マイページの定期便管理ページのアコーディオンを開いてスクロール
function openSubscription() {
  $('.accordion_wide_common_li.subscription .label').addClass('open');
  $('.accordion_wide_common_li.subscription .detail').slideDown();

  var offsetY = 50;
  if($(window).width() <= 1050){
    offsetY = -10;
  }

  const targetPos = $('.accordion_wide_common_li.subscription').offset().top - $(window).scrollTop() - offsetY;
  
  setTimeout(() => {
    window.scroll({
      top: targetPos,
      behavior: 'smooth'
    });
  }, 1000);
  
}

